import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import useSubjectsContext, { SubjectsContextProvider } from './context';
import { htmlToText, assertDefined } from '~/helpers/data';
import useDocumentHead, { useCanonicalLink } from '~/helpers/use-document-head';
import Hero from './hero';
import JITLoad from '~/helpers/jit-load';
import { AllSubjectsAboutOpenStax } from './about-openstax';
import LoadSubject from './specific/specific';
import './subjects.scss';
const importLanguageSelector = () => import('./language-selector-section.js');
const importSubjectsListing = () => import('./import-subjects-listing.js');
const importTutorAd = () => import('./import-tutor-ad.js');
const importInfoBoxes = () => import('./import-info-boxes.js');
const importPhilanthropicSupport = () => import('./import-philanthropic-support.js');
function SEOSetup() {
    const { title, pageDescription } = assertDefined(useSubjectsContext());
    useDocumentHead({
        title,
        description: pageDescription ? htmlToText(pageDescription) : undefined
    });
    useCanonicalLink();
    return null;
}
export function SubjectsPage() {
    const { translations } = assertDefined(useSubjectsContext());
    const otherLocales = (translations === null || translations === void 0 ? void 0 : translations.length)
        ? translations[0].value.map((t) => t.locale)
        : [];
    return (React.createElement("main", { className: "subjects-page" },
        React.createElement(SEOSetup, null),
        React.createElement(Hero, null),
        React.createElement("img", { className: "strips", src: "/dist/images/components/strips.svg", height: "10", alt: "", role: "separator" }),
        React.createElement(JITLoad, { importFn: importLanguageSelector, otherLocales: otherLocales, addPolish: true }),
        React.createElement(JITLoad, { importFn: importSubjectsListing }),
        React.createElement(JITLoad, { importFn: importTutorAd }),
        React.createElement(AllSubjectsAboutOpenStax, null),
        React.createElement(JITLoad, { importFn: importInfoBoxes }),
        React.createElement(JITLoad, { importFn: importPhilanthropicSupport })));
}
function RedirectSlash() {
    const { pathname } = useLocation();
    if (pathname.endsWith('/')) {
        return React.createElement(Navigate, { to: pathname.slice(0, -1), replace: true });
    }
    return React.createElement(SubjectsPage, null);
}
export default function SubjectsRouter() {
    return (React.createElement(SubjectsContextProvider, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/", element: React.createElement(RedirectSlash, null) }),
            React.createElement(Route, { path: "view-all", element: React.createElement(Navigate, { to: "/subjects", replace: true }) }),
            React.createElement(Route, { path: "ap", element: React.createElement(Navigate, { to: "/subjects/high-school", replace: true }) }),
            React.createElement(Route, { path: ":subject", element: React.createElement(LoadSubject, null) }))));
}
